export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-apple-9e92a34c9ae3c933845510608b2037d8.svg";